import sendOtpReducer from '../slice/sendOtp'
import otpReducer from '../slice/validateOtp'
import uploadFileReducer from '../upload/uploadFileReducer'
import {combineReducers} from 'redux'
import userReducer from '../slice/userSlice'
import businessTypeReducer from '../slice/buninessTypeSlice'
import categoryTypeReducer from '../slice/categorySlice'
import orderTypeReducer from '../slice/orderSlice'
import transactionTypeReducer from '../slice/transactionSlice'
import productTypeReducer from '../slice/productSlice'
import subCatTypeReducer from '../slice/subCatSlice'
import loginUserSlice from '../slice/loginUserSlice'
import eightySixTypeReducer from '../slice/eightySixSlice'
import rewardPlanMapTypeReducer from '../slice/rewardPlanMapSlice'
import rewardPointMapTypeReducer from '../slice/rewardPointMapSlice'
import companyTypeReducer from '../slice/companySlice'
// import customerTypeReducer from '../slice/customerSlice'
import checklistTypeReducer from '../slice/checklistSlice'
import cleanerTypeReducer from '../slice/cleanerSlice'
import jobTypeReducer from '../slice/jobSlice'
import taskTypeReducer from '../slice/taskSlice'
import workorderTypeReducer from '../slice/workorderSlice'
import businessTypeMasterReducer from '../slice/businessTypeMasterSlice'
import workorderpaymentTypesReducer from '../slice/master/workorderpaymentTypesSlice'
import tabdataReducer from '../slice/master/tabdataSlice'
import mainworkorderstatusReducer from '../slice/master/mainworkorderstatusSlice'
import WorkorderStatusReducer from '../slice/master/WorkorderStatusSlice'
import approvalstatusReducer from '../slice/master/approvalstatusSlice'
import paymentstatusReducer from '../slice/master/paymentstatusSlice'
import taskstatusReducer from '../slice/master/taskstatusSlice'
import candidatestatusReducer from '../slice/master/candidatestatusSlice'
import jobstatusReducer from '../slice/master/jobstatusSlice'
import indiJobStatusReducer from '../slice/master/indiJobStatusSlice'
import applicationStatusReducer from '../slice/master/applicationStatusSlice'
import workOrderApplicationStatusReducer from '../slice/master/workOrderApplicationStatusSlice'
import customerTypeReducer from '../slice/master/customerTypeSlice'
import intenttypeReducer from '../slice/master/intenttypeSlice'
import provinceReducer from '../slice/master/provinceSlice'
import individualJobStatusReducer from '../slice/master/individualJobStatusSlice'  
import branchservicetypeReducer from '../slice/master/branchservicetypeSlice'    
import scheduleReducer from '../slice/master/scheduleSlice'    
import benefitsReducer from '../slice/master/benefitsSlice'    
import supplementalpayReducer from '../slice/master/supplementalpaySlice'    
import paytypeReducer from '../slice/master/paytypeSlice'    
import employmentReducer from '../slice/master/employmentSlice'    
import jobtypeReducer from '../slice/master/jobTypeSlice'
import appSettingsSlice from '../slice/master/appSettingsSlice'    

  
 const rootReducer = combineReducers({
  sendOtp: sendOtpReducer,
  otp: otpReducer,
  file: uploadFileReducer,
  user: userReducer,
  businessType: businessTypeReducer,
  categoryType: categoryTypeReducer,
  order: orderTypeReducer,
  transaction: transactionTypeReducer,
  product: productTypeReducer,
  subCat: subCatTypeReducer,
  loginUser: loginUserSlice,
  eightySix: eightySixTypeReducer,
  rewardPlanMap: rewardPlanMapTypeReducer,
  rewardPointMap: rewardPointMapTypeReducer,
  company: companyTypeReducer,
  customer: customerTypeReducer,
  checklist: checklistTypeReducer,
  cleaner: cleanerTypeReducer,
  job: jobTypeReducer,
  task: taskTypeReducer,
  workorder: workorderTypeReducer,
  businessTypeMaster:businessTypeMasterReducer,
workorderpaymentTypes:workorderpaymentTypesReducer,
tabdata:tabdataReducer,
mainworkorderstatus:mainworkorderstatusReducer,
WorkorderStatus:WorkorderStatusReducer,
approvalstatus:approvalstatusReducer,
paymentstatus:paymentstatusReducer,
taskstatus:taskstatusReducer,
candidatestatus:candidatestatusReducer,
jobstatus:jobstatusReducer,
indiJobStatus:indiJobStatusReducer,
applicationStatus:applicationStatusReducer,
workOrderApplicationStatus:workOrderApplicationStatusReducer,
customerType:customerTypeReducer,
intenttype:intenttypeReducer,
province:provinceReducer,
individualJobStatus:individualJobStatusReducer,
branchservicetype:branchservicetypeReducer,
schedule:scheduleReducer,
supplementalpay:supplementalpayReducer,
benefits:benefitsReducer,
paytype:paytypeReducer,
employmenttype:employmentReducer,
jobtype:jobtypeReducer,
appSettings:appSettingsSlice
})
export { rootReducer };
export type RootState = ReturnType<typeof rootReducer>;
